import { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Buy from "./Buy";
import Sell from "./Sell";
import Redeem from "./Redeem";
import Spot from "./Spot";
// import Tabss from "../Tabss";

export default function FintsoTransactions() {
  const [activeTab, setActiveTab] = useState("BUY");


  return (
    <Box>
      {/* <Tabss/> */}
      <Box sx={{ display: "flex", justifyContent: "center", }}>
        <Button
          variant={activeTab === "BUY" ? "contained" : "outlined"}
          onClick={() => setActiveTab("BUY")}
          sx={{
            marginRight: { xs: 1, sm: 2 }, fontSize: { xs: "11px", sm: "13px", md: "14px" },
          }}
        >
          BUY
        </Button>
        <Button
          variant={activeTab === "SELL" ? "contained" : "outlined"}
          onClick={() => setActiveTab("SELL")}
          sx={{
            marginRight: { xs: 1, sm: 2 }, fontSize: { xs: "11px", sm: "13px", md: "14px" },
          }}        >
          SELL
        </Button>
        <Button
          variant={activeTab === "REDEEM" ? "contained" : "outlined"}
          onClick={() => setActiveTab("REDEEM")}
          sx={{
            marginRight: { xs: 1, sm: 2 }, fontSize: { xs: "11px", sm: "13px", md: "14px" },
          }}        >
          REDEEM
        </Button>
        <Button
          variant={activeTab === "SPOT" ? "contained" : "outlined"}
          onClick={() => setActiveTab("SPOT")}
          sx={{
            fontSize: { xs: "11px", sm: "13px", md: "14px" },
          }}
        >
          SPOT
        </Button>
      </Box>

      {activeTab === "BUY" && (
        <div>
          <Buy />
        </div>
      )}

      {activeTab === "SELL" && (
        <div>
          <Sell />
        </div>
      )}
      {activeTab === "REDEEM" && (
        <div>
          <Redeem />
        </div>
      )}
      {activeTab === "SPOT" && (
        <div>
          <Spot />
        </div>
      )}
    </Box>
  );
}



// import { useState } from "react";
// import Box from "@mui/material/Box";
// import Button from "@mui/material/Button";
// import Buy from "./Buy";
// import Sell from "./Sell";
// import Redeem from "./Redeem";
// import Spot from "./Spot";
// // import Tabss from "../Tabss";

// export default function FintsoTransactions() {
//   const [activeTab, setActiveTab] = useState("BUY");

//   return (
//     <Box>
//       {/* <Tabss/> */}
//       <Box sx={{ display: "flex", justifyContent: "center"  }}>
//         <Button
//           variant={activeTab === "BUY" ? "contained" : "outlined"}
//           onClick={() => setActiveTab("BUY")}
//           sx={{ marginRight: 2 }}
//         >
//           BUY
//         </Button>
//         <Button
//           variant={activeTab === "SELL" ? "contained" : "outlined"}
//           onClick={() => setActiveTab("SELL")}
//           sx={{ marginRight: 2 }}
//         >
//           SELL
//         </Button>
//         <Button
//           variant={activeTab === "REDEEM" ? "contained" : "outlined"}
//           onClick={() => setActiveTab("REDEEM")}
//           sx={{ marginRight: 2 }}
//         >
//           REDEEM
//         </Button>
//         <Button
//           variant={activeTab === "SPOT" ? "contained" : "outlined"}
//           onClick={() => setActiveTab("SPOT")}
//         >
//           SPOT
//         </Button>
//       </Box>

//       {activeTab === "BUY" && (
//         <div>
//           <Buy />
//         </div>
//       )}

//       {activeTab === "SELL" && (
//         <div>
//           <Sell />
//         </div>
//       )}
//       {activeTab === "REDEEM" && (
//         <div>
//           <Redeem />
//         </div>
//       )}
//       {activeTab === "SPOT" && (
//         <div>
//           <Spot />
//         </div>
//       )}
//     </Box>
//   );
// }
